/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NoneInputs */

const en_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- None --`)
};

const fr_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Aucun --`)
};

const de_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Keine --`)
};

const it_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Nessuno --`)
};

const ru_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Никто --`)
};

const es_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Ninguno --`)
};

const zh_cn2_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` -  没有任何  - `)
};

const ja_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` -  なし  - `)
};

const hi_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- कोई नहीं --`)
};

const pt_pt2_none = /** @type {(inputs: NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Nenhum --`)
};

/**
* | output |
* | --- |
* | "-- None --" |
*
* @param {NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const none = /** @type {((inputs?: NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_none(inputs)
	if (locale === "de") return de_none(inputs)
	if (locale === "it") return it_none(inputs)
	if (locale === "ru") return ru_none(inputs)
	if (locale === "es") return es_none(inputs)
	if (locale === "zh-CN") return zh_cn2_none(inputs)
	if (locale === "ja") return ja_none(inputs)
	if (locale === "hi") return hi_none(inputs)
	if (locale === "pt-PT") return pt_pt2_none(inputs)
	return en_none(inputs)
});